import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  Alert,
} from "@mui/material";
import axios from "axios";
import Header from "components/Header";
import { DataGrid } from '@mui/x-data-grid';
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

const Offer = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [currentOffer, setCurrentOffer] = useState(null);
  const [title, setTitle] = useState("");
  const [tech, setTech] = useState([{ title: "", image: "" }]);
  const [image, setImage] = useState([ ]);
  const [errorMessage, setErrorMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  useEffect(() => {
    fetchOffers();
  }, []);

  const fetchOffers = async () => {
    try {
      const response = await axios.get(`${apiUrl}/offer/getoffer`);
      setData(response.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading(false);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleFileChange = (index, event) => {
    const selectedImage = event.target.files[0];
    if (selectedImage) {
      handleImageUpload(selectedImage, (filePath) => {
        const updatedTech = [...tech];
        updatedTech[index].image = filePath; // Set the image path for the specific tech
        setTech(updatedTech);
      });
    }
  };
  const handleFileChange1 = (index, event) => {
    const selectedImage = event.target.files[0];
    if (selectedImage) {
      handleImageUpload(selectedImage, (filePath) => {
        const updatedImage = [...image];
        updatedImage[index].image = filePath; // Set the image path for the specific tech
        setImage(updatedImage);
      });
    }
  };

  const handleImageUpload = async (file, callback) => {
    const formData = new FormData();
    formData.append("image", file);

    try {
      const response = await axios.post(`${apiUrl}/upload`, formData);
      console.log("this is image path>>:", response.data.filePath);
      // callback(response.data.filePath); // Use callback to set the image path
      callback(response.data.url);
    } catch (error) {
      console.error("Error uploading image:", error);
      setErrorMessage("Error uploading image.");
      setSnackbarOpen(true);
    }
  };

  const handleOpenModal = (offer) => {
    if (offer) {
      setCurrentOffer(offer);
      setTitle(offer.title);
      setTech(offer.tech);
      setImage(offer.image)
    } else {
      setCurrentOffer(null);
      setTitle("");
      setTech([{ title: "", image: "" }]);
      setImage([{image:""}])
    }
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setCurrentOffer(null);
  };

  const handleTechChange = (index, e) => {
    const updatedTech = tech.map((item, i) => (
      i === index ? { ...item, [e.target.name]: e.target.value } : item
    ));
    setTech(updatedTech);
  };

  const handleAddTech = () => {
    setTech([...tech, { title: "", image: "" }]); // Add a new technology object
  };
  const handleAddImage = () => {
    setImage([...image, {image: "" }]); // Add a new technology object
  };

  const handleRemoveTech = (index) => {
    setTech(tech.filter((_, i) => i !== index));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!title || tech.some(t => !t.title || !t.image)||image.some(t => !t.image)) {
      setErrorMessage("Please fill all required fields!");
      setSnackbarOpen(true);
      return;
    }
    const postData = {
      title,
      tech,
      image,
    };

    try {
      const response = await axios.post(`${apiUrl}/offer/createoffer`, postData);
      setData((prevData) => [...prevData, response.data]);
      handleCloseModal();
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handleUpdate = async (event) => {
    event.preventDefault();
    if (!title || tech.some(t => !t.title || !t.image)||image.some(t => !t.image)) {
      setErrorMessage("Please fill all required fields!");
      setSnackbarOpen(true);
      return;
    }
    const updateData = {
      title,
      tech,
      image,
    };

    try {
      const response = await axios.put(`${apiUrl}/offer/updateoffer/${currentOffer._id}`, updateData);
      setData((prevData) =>
        prevData.map((item) => (item._id === currentOffer._id ? response.data : item))
      );
      handleCloseModal();
    } catch (error) {
      console.error("Error updating offer:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${apiUrl}/offer/deleteoffer/${id}`);
      setData((prevData) => prevData.filter((item) => item._id !== id));
    } catch (error) {
      console.error("Error deleting offer:", error);
    }
  };

  const columns = [
     
    { field: "title", headerName: "Title", flex: 1 },
    { field: "tech", headerName: "Technologies", flex: 1, renderCell: (params) => (
      <Typography variant="body2">
        {params.value.map((t) => t.title).join(", ")}
      </Typography>
    )},
    { field: "image", headerName: "Image", flex: 1,
      
      renderCell: (params) => (
       
      <img src={params.row.tech[0].image} alt={params.row.title} width="50" height="50" />
    )},
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => (
        <>
          <Button variant="contained"  style={{marginRight: 8}} color="primary" size="small" onClick={() => handleOpenModal(params.row)}>
            Update
          </Button>
          <Button variant="contained" color="secondary" size="small" onClick={() => handleDelete(params.row._id)}>
            Delete
          </Button>
        </>
      ),
    },
  ];

  return (
    <Box m="1.5rem 2.5rem">
      <Header title="OUR OFFERING" subtitle="List of Our Offering" />
      <Button variant="contained" color="primary" onClick={() => handleOpenModal(null)}>
        Add New Offer
      </Button>

      <Dialog open={openModal} onClose={handleCloseModal}>
        <DialogTitle>{currentOffer ? "Update Offer" : "Add New Offer"}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Title"
            type="text"
            fullWidth
            variant="outlined"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <Typography variant="subtitle1">Technologies</Typography>
          {tech.map((t, index) => (
            <Box key={index} display="flex" alignItems="center" mb={2}>
              <TextField
                margin="dense"
                label="Tech Title"
                name="title"
                type="text"
                variant="outlined"
                value={t.title}
                onChange={(e) => handleTechChange(index, e)}
                style={{ flex: 1, marginRight: "8px" }}
              />
              <Button
                variant="outlined"
                component="label"
                startIcon={<CloudUploadIcon />}
              >
                Upload Image
                <input
                  type="file"
                  hidden
                  onChange={(e) => handleFileChange(index, e)} // Pass the index to the handler
                />
              </Button>
              {t.image && (
                <Typography variant="body2" sx={{ mt: 1 }}>
                  <img src={t.image} alt="image" width="50" height="50" />
                </Typography>
              )}
              <Button variant="outlined" color="secondary" onClick={() => handleRemoveTech(index)}>
                Remove
              </Button>
            </Box>
          ))}
          <Button variant="contained" color="primary" onClick={handleAddTech}>
            Add Technology
          </Button>
          {image.map((t, index) => (
            <Box key={index} display="flex" alignItems="center" mb={2}>
              <Button
                variant="outlined"
                component="label"
                startIcon={<CloudUploadIcon />}
              >
                Upload Image
                <input
                  type="file"
                  hidden
                  onChange={(e) => handleFileChange1(index, e)} // Pass the index to the handler
                />
              </Button>
              {t.image && (
                <Typography variant="body2" sx={{ mt: 1 }}>
                  <img src={t.image} alt="image" width="50" height="50" />
                </Typography>
              )}
              <Button variant="outlined" color="secondary" onClick={() => handleRemoveTech(index)}>
                Remove
              </Button>
            </Box>
          ))}
          <Button variant="contained" color="primary" onClick={handleAddImage}>
            Add More Image
          </Button>
        </DialogContent>
         
        <DialogActions>
          <Button onClick={handleCloseModal} color="primary">
            Cancel
          </Button>
          <Button onClick={currentOffer ? handleUpdate : handleSubmit} color="primary">
            {currentOffer ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </Dialog>

      <Box mt="40px" height="75vh">
        <DataGrid
          loading={isLoading}
          getRowId={(row) => row._id}
          rows={data || []}
          columns={columns}
          pageSize={5}
        />
      </Box>
      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
        <Alert onClose={handleSnackbarClose} severity="error">
          {errorMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Offer;
